<template>
  <div class="header" :class="{ 'search-result-page': isSearch,'header-page': isIndex }">
    <div class="t-top">
      <div class="wp" :class="{'caseSearch' : isSearch}">
        <!-- hd-top -->
        <div class="hd-top fix">
          <div class="logo" v-if="!isSearch">
            <a href="index.html">
              <img src="static/images/logo.png" alt />
            </a>
          </div>
          <div class="logoSearch" v-else>
            <a href="index.html">
              <img src="static/images/f1-tit03.png" alt="首页" />
            </a>
          </div>
          <span @click="openNav" :class="['menuBtn',{'open': isOpen}]"></span>
          <!-- hd-rightBtn -->
          <div v-if="!logined" class="hd-rightBtn">
            <a href="javascript:void(0)" class="login" @click="login()">登录</a>
            <a>/</a>
            <a href="regist.html" class="sign">注册</a>
          </div>
          <div v-if="logined" class="hd-rightBtnNo">
            <a href="personal.html" :title="userName" class="username" target="_blank">{{userName}}</a>
            <a href="javascript:void(0)" class="logout" @click="logout('self_exit')">退出</a>
          </div>
          <!-- hd-rightBtn end -->
          <!-- nav -->
          <div :class="['nav',{'open': isOpen}]">
            <ul class="ul-nav fix">
              <li :class="{'on': tab === 1}">
                <a href="index.html" class="v1">首页</a>
              </li>
              <li :class="{'on': tab === 2}" v-if="hasPriv('casewrite')">
                <a @click="tabHandler(2)" href="javascript:;" class="v1 case">案例编写</a>
              </li>
              <li :class="{'on': tab === 3}" v-if="hasPriv('caseexamine')">
                <a @click="tabHandler(3)" href="javascript:;" class="v1 case">案例审核</a>
              </li>
              <li :class="{'on': tab === 5}" v-if="hasPriv('casetask')">
                <a @click="tabHandler(5)" href="javascript:;" class="v1 case">审核任务分配</a>
              </li>
              <li :class="{'on': tab === 4}" v-if="hasPriv('casestat')">
                <a @click="tabHandler(4)" href="javascript:;" class="v1 case">案例统计</a>
              </li>
            </ul>
          </div>
          <!-- nav end -->
        </div>
        <!-- hd-top end -->
      </div>
    </div>
    <div class="wp">
      <div class="hd-search">
        <div class="tit" v-if="!isSearch">
          <img src="static/images/search-logo.png" alt />
        </div>
        <div class="search">
          <div class="inp">
            <input type="text" class="text" placeholder="请输入搜索词" v-model="q" @keyup.enter="query" />
          </div>
          <div class="submit">
            <input type="submit" placeholder="搜索" @click="query" value="搜索" />
          </div>
        </div>
      </div>
      <messageDialog :errorMessage="message" :show="messageShow" v-show="messageShow" @showModal="getMsg"></messageDialog>
    </div>
    <div class="wp" v-if="isIndex">
      <div class="system-list" style="padding-left: 10%;">
        <span class="system-item" v-for="item in systems" :key="item.innerCode" @click="toSystemList(item.innerCode)"><span>{{item.name}}</span></span>
      </div>
      <messageDialog :errorMessage="message" :show="messageShow" v-show="messageShow" @showModal="getMsg"></messageDialog>
    </div>
    <ie-tips/>
  </div>
  <!-- 头部 end -->
</template>

<script>
import ieTips from "../components/ieTips.vue"
import messageDialog from '../components/messageDialog'
import priv from '../../utils/priv.js'
import util from '../../utils/util'
import axios from 'axios'

export default {
  props: {
    // 设置免登录访问 true 为免登录
    noLogin: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    searchKey: {
      type: String,
      default: ''
    },
    tab: {
      type: Number,
      default: 1
    }
  },
  name: 'mHeader',
  data: () => {
    return {
      custom: {},
      isOpen: false,
      messageCount: 0,
      q: '',
      message: '',
      messageShow: false,
      logined: false,
      userName: '',
      zasServerUrl: '',
      systems: [],
      isIndex: false
    }
  },
  watch: {
    searchKey(a, o) {
      this.q = this.searchKey ? this.searchKey : ''
    },
    logined(value) {
      this.$emit('isLogin', value)
    }
  },
  components: {
    messageDialog,
    ieTips
  },
  async created() {
    let pathname = location.pathname
    if ( pathname === '/' || pathname === '/index.html' || pathname === '/pbl/index.html' || pathname === '/pbl/'){
      this.isIndex = true
    }
    this.isLogin()
    let result = await priv.checkButtonPriv()
    this.custom = Object.assign({}, result)
    this.initSystems()
  },
  methods: {
    async initSystems() {
      let resp = await this.axios.get('/front/classtype/xt/classify').then(res => res.data.data)
      this.systems = resp
    },
    async isOnline(logined) {
      let referer = localStorage.getItem('Referer')
        ? localStorage.getItem('Referer')
        : location.href
      let configs = await this.axios.get('/front/member/login/config?Referer=' + encodeURIComponent(referer)).then(res => res.data.data)
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let zasClientId = configs ? configs.clientID : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/onlineValidata?' + new Date(), data, { withCredentials: true }).then(res => {
        res = res.data
        if (res.success) {
          if (!logined) {
            localStorage.setItem('Referer', location.href)
            window.location.href = './login.html'
          }
        } else {
          if (logined) {
            this.logout('self_exit')
          }
        }
      })
    },
    async isLogin() {
      let resp = await this.axios
        .get('/front/member/login/username')
        .then(resp => resp.data)
      if (resp.status === 1) {
        this.logined = true
        this.userName = resp.data.username
        if (!resp.data.backgroundLogin){
          this.isOnline(true)
        } 
      } else {
        this.isOnline(false)
      }
    },
    openNav() {
      this.isOpen = !this.isOpen
    },
    hasPriv(k) {
      if (this.custom.keys) {
        return this.custom.keys[k] === 1
      }
      return false
    },
    async tabHandler(val) {
      // 判断是否登录
      if (!this.logined && !this.noLogin) {
        util.showWarningMessage('您还没有登录，请先登录！');
        return
      }
      let _this = this
      if (2 === val) {
        if (_this.custom.casewrite.msg) {
          util.showInfoMessage(_this.custom.casewrite.msg)
          if (_this.custom.casewrite.redirecturl) {
            setTimeout(function() {
              location.href = _this.custom.casewrite.redirecturl
            }, _this.custom.casewrite.timeout)
          }
        } else {
          window.location.href ='./case.html'
        }
        //  this.$confirm('编写案例的注意事项', '编写案例需知', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '取消',
        //     type: 'warning'
        //   }).then(async () => {

        //   }).catch(() => {})
      }
      if (3 === val) {
        let result = await priv.checkCaseAudit()
        if (result === 2 || result === 3 || result === 5 || result === 6) {
          window.location.href = './caseAudit.html'
        } else {
          return
        }
      }
      if (4 === val) {
        window.location.href = './caseTab.html'
      }
      if (5 === val) {
        window.location.href = './assignCase.html'
      }
    },
    login() {
      localStorage.setItem('Referer', location.href)
      window.location.href = 'login.html'
    },
    async logout(action) {
      let referer = localStorage.getItem('Referer') ? localStorage.getItem('Referer') : location.href
      let configs = await this.axios
      .get(
        '/front/member/login/config?Referer=' + encodeURIComponent(referer)
      )
      .then(res => res.data.data)
      let zasClientId = configs ? configs.clientID : ''
      let zasServerUrl = configs ? configs.zasServerUrl : ''
      let data = {
        Validate: getInfo(),
        client_id: zasClientId
      }
      axios.post(zasServerUrl + 'zapiv3/browser/login/logout?' + new Date().getTime(), data, { withCredentials: true }).then(res => {
        this.reload(referer, action)
      })
    },
    async reload(referer, action){
      let configs = await this.axios
        .get('/front/member/logout?Referer=' + encodeURIComponent(referer) + '&action=' + action)
        .then(res => res.data.data)
        if ('self_exit' === action){
          let zasLogout = configs ? configs.ssologout : ''
          // window.location.href = zasLogout
          window.location.href = 'index.html'
        }
    },
    toSystemList(innercode) {
      window.location.href = `./search.html?system=${innercode}`
    },
    async query() {
      if (this.q !== '' && this.q.trim() !== '') {
        if (this.q.match(/[$#&<>]/)){
          util.showInfoMessage('请勿在搜索条件中输入特殊符号$、#、&、<、>')
          return
        }
        window.location.href = `./search.html?q=${encodeURIComponent(encodeURIComponent(this.q))}`
      }else {
        window.location.href = `./search.html`
      }
    },
    getMsg(data) {
      this.messageShow = data
    }
  }
}
</script>
<style scoped>
.system-item {
  width: 25%;
  display: inline-block;
  cursor: pointer;
  color: #fff;
  margin-top: 30px;
  text-align: left;

}
.system-item span{
  border-bottom:1px solid #FFF;
  padding-bottom: 5px;
}
.system-item span:hover{
  border-bottom:1px solid #1ad5b1;
  color:#1ad5b1;
  font-weight: bold;
}
ol,
ul {
  margin: 0;
  padding: 0;
}
.t-top {
  border-bottom: 1px solid #9db4e1;
}
.hd-top {
  padding-top: 20px;
  margin-bottom: 0;
}
.hd-search {
  margin-top: 50px;
  margin-bottom: 20px;
}
a:hover {
  color: #ffffff;
  text-decoration: none;
}
.hd-search .search .select {
  width: 85px;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  text-align: center;
  background: #f9f9f9;
  color: #83838f;
  font-size: 16px;
}
.case {
  background: #1ad5b1 !important;
  margin-right: 30px;
  padding: 0 7px;
  /* margin-right:50px */
}
.logoSearch{
  width: 358px;
  display: flex;
  align-items: center;
  float: left;
}
.logoSearch img {
  height: auto;
  width: 100%;
}
.caseSearch {
  max-width: 1200px;
}
@media only screen and (max-width: 767px) {
  .logoSearch{width: 168px;}
  .logoSearch img {height: 20px;width: auto;}
  
}
@media only screen and (max-width: 321px) {
  .hd-rightBtnNo .username {
    width: 60px;
    margin-left: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/mHeader.vue